import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Checkbox, Form, Select } from 'antd';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import { UPSDepositRequestApi } from '../../../../../api/request/wallet/deposit.js';

const accountTypeOptions = [
    { label: 'UPI', value: 1 },
    { label: 'RTGS/ IMPS/ NEFT', value: 2 },
];

const UPS = ({ amount, paymentMethod, resetAll }) => {
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state.user);
    const [isDepositLoading, setIsDepositLoading] = useState(false);

    const handleSubmit = async (values) => {
        if (!amount) {
            toast.error('Please enter deposit amount');
            return;
        }
        setIsDepositLoading(true);
        try {
            const deposiParams = {
                userId: userDetails?._id,
                paymentGatwayId: paymentMethod?.id,
                amount: Number(amount),
                loginTerminalId: 0,
                accountType: values?.accountType,
            };
            const { data } = await UPSDepositRequestApi(deposiParams);
            if (data?.success) {
                toast.success(data?.message);
                form.resetFields();
                resetAll();
                if (data?.data?.redirect_url) {
                    window.location.href = data?.data?.redirect_url;
                }
            }
        } catch (error) {
            toast.error(error?.response?.data?.error?.message || 'Deposit failed.');
        } finally {
            setIsDepositLoading(false);
        }
    };

    return (
        <div>
            <Form form={form} layout='vertical' className='space-y-5' onFinish={handleSubmit}>
                <Form.Item
                    name="accountType"
                    label={<span className="text-lg text-gray-500 font-medium">Select Payment Method</span>}
                    rules={[{ required: true, message: 'Please select a payment method.' }]}
                >
                    <Select
                        placeholder="Select Payment Method"
                        size="large"
                        options={accountTypeOptions}
                    />
                </Form.Item>

                <Form.Item
                    name='conditions'
                    valuePropName="checked"
                    rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')) }]}
                >
                    <Checkbox className='mt-4'>
                        Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link>
                    </Checkbox>
                </Form.Item>

                <LoadableButton
                    className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
                    type="submit"
                    lable='Submit'
                    isLoading={isDepositLoading}
                    loadingLable='Adding request...'
                />
            </Form>
        </div>
    )
}

export default UPS
